import { useEffect, useRef, useState } from 'react';
import { Nav, Tab } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { MdEmail } from 'react-icons/md';
import { FaPhoneAlt } from 'react-icons/fa';
import { Modal, Button, Form, Dropdown } from 'react-bootstrap';
import ConfirmationModal from './Modal/ConfirmationModal';
import { getGeneralQueries, updateQuery, updateQueryAgent, addConversation } from '../../services/queryServices';

export const priorityColors = {
  high: '#FF0000',
  medium: '#FFA500',
  low: '#32CD32',
  critical: '#8B0000',
};

const DropdownBlog = ({ viewConversations, editQuery, addMessage, agent }) => {
  return (
    <>
      <Dropdown className="dropdown">
        <Dropdown.Toggle as="div" className="btn-link i-false" data-bs-toggle="dropdown" aria-expanded="false">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M11 12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12Z"
              stroke="#262626"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M18 12C18 12.5523 18.4477 13 19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12Z"
              stroke="#262626"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M4 12C4 12.5523 4.44772 13 5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12Z"
              stroke="#262626"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {agent && <Dropdown.Item onClick={editQuery}>Edit Query</Dropdown.Item>}
          <Dropdown.Item onClick={addMessage}>Add Comments</Dropdown.Item>
          <Dropdown.Item onClick={viewConversations}>View Comments</Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

const Queries = () => {
  const [queries, setQueries] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showConfirmation, setConfirmation] = useState(false);
  const [selectedQuery, setSelectedQuery] = useState(null);
  const [statusFilter, setStatusFilter] = useState('');
  const [priorityFilter, setPriorityFilter] = useState('');
  const [showConversationModal, setShowConversationModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showAddMessageModal, setShowAddMessageModal] = useState(false);
  const [employeeId, setEmployeeId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalQueries, setTotalQueries] = useState(0);
  const [comment, setComment] = useState('');
  const limit = 10; // Items per page
  const [status, setStatus] = useState(selectedQuery?.status || 'Open');
  const [priority, setPriority] = useState(selectedQuery?.priority || 'Low');

  // Filter queries based on status and priority
  const filteredQueries = queries.filter((query) => {
    const matchesStatus = !statusFilter || query.status.toLowerCase() === statusFilter.toLowerCase();
    const matchesPriority = !priorityFilter || query.priority.toLowerCase() === priorityFilter.toLowerCase();
    return matchesStatus && matchesPriority;
  });
  const fetchQueries = async (page = 1) => {
    try {
      const response = await getGeneralQueries(page, limit);
      setQueries(response?.data); // Assuming response is an array of queries
      setCurrentPage(response.page);
      setTotalPages(response.totalPages);
      setTotalQueries(response.totalQueries);
    } catch (error) {
      setError(error.response?.data?.message || 'Failed to fetch queries');
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchQueries(currentPage);
    const user = JSON.parse(localStorage.getItem('user'));
    if (user && user.id) {
      setEmployeeId(user.id);
    }
  }, [currentPage]);
  const handleSave = () => {
    updateQuery(selectedQuery);
    setShowModal(false);
  };

  // const updateQuery = (updatedQuery) => {
  //   setQueries((prev) => prev.map((query) => (query.id === updatedQuery.id ? updatedQuery : query)));
  // };

  const deleteQuery = () => {
    setQueries((prev) => prev.filter((query) => query.id !== selectedQuery.id));
    setConfirmation(false);
    setSelectedQuery(null);
  };

  const [data, setData] = useState(document.querySelectorAll('#example2_wrapper tbody tr'));
  const sort = 8;
  const activePag = useRef(0);
  const [test, settest] = useState(0);

  // Active data
  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove('d-none');
      } else {
        data[i].classList.add('d-none');
      }
    }
  };
  // use effect
  useEffect(() => {
    setData(document.querySelectorAll('#example2_wrapper tbody tr'));
    //chackboxFun();
  }, [test]);

  // Active pagginarion
  activePag.current === 0 && chageData(0, sort);
  // paggination
  let paggination = Array(Math.ceil(data.length / sort))
    .fill()
    .map((_, i) => i + 1);

  // Active paggination & chage data
  const onClick = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
    settest(i);
  };

  const handleViewConversations = (query) => {
    setSelectedQuery(query);
    setShowConversationModal(true);
  };

  const handleEditQuery = (query) => {
    setSelectedQuery(query);
    setShowEditModal(true);
    setStatus(query.status);
    setPriority(query.priority);
  };

  const handleAddMessage = (query) => {
    setSelectedQuery(query);
    setShowAddMessageModal(true);
  };
  const handleUpdate = async (selectedQuery) => {
    try {
      // Prepare updated data
      const updatedData = { status, priority };
      // Call API to update query
      await updateQuery(selectedQuery._id, updatedData);

      // Close modal
      setShowEditModal(false);
      fetchQueries();

      // Refresh queries list (to reflect changes in UI)
    } catch (error) {
      console.error('Failed to update query:', error);
    }
  };

  const handleAgentChange = async (bookingId, newStatus) => {
    try {
      const user = JSON.parse(localStorage.getItem('user'));

      const updatedData = {
        status: newStatus,
        agent: newStatus === 'Managed' ? user.id : null, // Assign or unassign agent
      };
      await updateQueryAgent(bookingId, updatedData);
      // setManageStatus(status); // Update UI state
      setQueries((prevData) =>
        prevData.map((booking) => (booking._id === bookingId ? { ...booking, agent: updatedData.agent } : booking))
      );
    } catch (error) {
      console.error('Error updating booking status:', error);
    }
  };

  const handleSendMessage = async () => {
    if (!comment.trim()) return; // Prevent empty messages

    setLoading(true);
    setError(null);

    try {
      let newConversation = {
        queryId: selectedQuery?._id,
        senderType: 'Employee',
        text: comment,
      };

      const res = await addConversation(newConversation);

      setComment(''); // Clear input field
    } catch (err) {
      setError('Failed to send message.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h3>Customer Queries</h3>
      <Tab.Container defaultActiveKey="All">
        <div className="mt-4 d-flex justify-content-between align-items-center flex-wrap">
          <div className="card-action coin-tabs mb-2">
            <Nav as="ul" className="nav nav-tabs" role="tablist">
              <Nav.Item as="li" className="nav-item">
                <Nav.Link className="nav-link" eventKey="All">
                  Queries
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </div>
          <div className="flex flex-row gap-x-2">
            <select className="form-select" value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
              <option value="">All Statuses</option>
              <option value="Resolved">Resolved</option>
              <option value="In Progress">Escalated</option>
              <option value="Open">Pending</option>
            </select>

            <select
              className="form-select ml-2"
              value={priorityFilter}
              onChange={(e) => setPriorityFilter(e.target.value)}
            >
              <option value="">All Priorities</option>
              <option value="High">High</option>
              <option value="Medium">Medium</option>
              <option value="Low">Low</option>
              <option value="Critical">Critical</option>
            </select>
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body p-0">
                <Tab.Content>
                  <Tab.Pane eventKey="All">
                    <div className="table-responsive">
                      <div id="room_wrapper" className="dataTables_wrapper no-footer">
                        <table className="table card-table display mb-4 dataTablesCard booking-table room-list-tbl dataTable no-footer">
                          <thead>
                            <tr role="row">
                              <th>Customer Name</th>
                              <th>Subject</th>
                              <th>Description</th>
                              <th>Status</th>
                              <th>Priority</th>
                              <th>Contact Informations</th>
                              <th>Date Raised</th>
                              <th>Action</th>

                              <th className="bg-none"></th>
                            </tr>
                          </thead>
                          <tbody>
                            {filteredQueries && filteredQueries.length > 0 ? (
                              filteredQueries?.map((query) => (
                                <tr role="row" className="odd text-base" key={query.id}>
                                  <td>
                                    <div className="room-list-bx d-flex align-items-center">
                                      <div>
                                        <span className="text-[16px] font-semibold">
                                          {query?.customerId?.name || 'User not found'}
                                        </span>
                                      </div>
                                    </div>
                                  </td>
                                  <td className="">
                                    <span className="fs-16 font-w500 text-nowrap">{query?.subject || 'N/A'}</span>
                                  </td>
                                  <td style={{ minWidth: '250px' }}>
                                    <div>
                                      <span className="fs-16 font-w500">{query?.description || 'N/A'}</span>
                                    </div>
                                  </td>
                                  <td>
                                    <div>
                                      <span className="fs-16 font-w500">{query?.status || 'N/A'}</span>
                                    </div>
                                  </td>
                                  <td>
                                    <div
                                      style={{
                                        backgroundColor: priorityColors[query?.priority?.toLowerCase()],
                                        color: 'white',
                                        padding: '5px 10px',
                                        borderRadius: '5px',
                                        textAlign: 'center',
                                      }}
                                    >
                                      <span className="fs-16 font-w500">{query?.priority || 'N/A'}</span>
                                    </div>
                                  </td>
                                  <td>
                                    <div>
                                      <Link
                                        to={`mailto:${query.customerId?.email}`}
                                        className="flex flex-row items-center"
                                      >
                                        <MdEmail /> {query.customerId?.email || 'N/A'}
                                      </Link>
                                      {query.customerId?.phone && (
                                        <Link
                                          to={`phone:${query.customerId?.phone}`}
                                          className="flex flex-row items-center"
                                        >
                                          <FaPhoneAlt /> {query.customerId?.phone || 'N/A'}
                                        </Link>
                                      )}
                                    </div>
                                  </td>

                                  <td>
                                    <div>
                                      <span className="fs-16 font-w500">
                                        {new Date(query.createdAt).toLocaleDateString() || 'N/A'}
                                      </span>
                                    </div>
                                  </td>

                                  <td>
                                    <Dropdown>
                                      <Dropdown.Toggle
                                        variant=""
                                        size="sm"
                                        style={{
                                          border: '1px solid',
                                          borderColor: '#28a745',
                                          borderRadius: '10px',
                                          color: '#28a745',
                                          padding: '10px 20px',
                                          fontWeight: '600',
                                          fontSize: '14px',
                                          minWidth: '100px',
                                          textAlign: 'center',
                                          backgroundColor: 'transparent',
                                        }}
                                      >
                                        {query.agent ? 'Managed' : 'Unmanaged'}
                                      </Dropdown.Toggle>
                                      <Dropdown.Menu style={{ minWidth: '100px' }}>
                                        <Dropdown.Item
                                          style={{ textAlign: 'center', padding: '10px 0' }}
                                          onClick={() => handleAgentChange(query._id, 'Managed')}
                                        >
                                          Managed
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                          style={{ textAlign: 'center', padding: '10px 0' }}
                                          onClick={() => handleAgentChange(query._id, 'Unmanaged')}
                                        >
                                          Unmanaged
                                        </Dropdown.Item>
                                      </Dropdown.Menu>
                                    </Dropdown>
                                  </td>

                                  <td>
                                    <DropdownBlog
                                      agent={query?.agent}
                                      viewConversations={() => handleViewConversations(query)}
                                      editQuery={() => handleEditQuery(query)}
                                      addMessage={() => handleAddMessage(query)}
                                    />
                                  </td>
                                </tr>
                              ))
                            ) : (
                            <tr>
                                <td colSpan="8" className="text-center py-3">
                                  No queries found.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                        <div className="d-sm-flex text-center justify-content-between align-items-center mt-3 mb-3">
                          <div className="dataTables_info">
                            Showing {queries.length > 0 ? (currentPage - 1) * limit + 1 : 0} to{' '}
                            {Math.min(currentPage * limit, totalQueries)} of {totalQueries} entries
                          </div>
                          <div className="dataTables_paginate paging_simple_numbers mb-0">
                            <Link
                              className={`paginate_button previous ${currentPage === 1 ? 'disabled' : ''}`}
                              to="/queries"
                              onClick={() => currentPage > 1 && setCurrentPage(currentPage - 1)}
                            >
                              <i className="fa fa-angle-double-left"></i> Previous
                            </Link>

                            <span>
                              {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                                <Link
                                  key={page}
                                  to="/queries"
                                  className={`paginate_button ${currentPage === page ? 'current' : ''}`}
                                  onClick={() => setCurrentPage(page)}
                                >
                                  {page}
                                </Link>
                              ))}
                            </span>

                            <Link
                              className={`paginate_button next ${currentPage === totalPages ? 'disabled' : ''}`}
                              to="/queries"
                              onClick={() => currentPage < totalPages && setCurrentPage(currentPage + 1)}
                            >
                              Next <i className="fa fa-angle-double-right"></i>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Tab.Pane>
                </Tab.Content>
              </div>
            </div>
          </div>
        </div>
      </Tab.Container>
      {/* Modal */}
      {showConversationModal && (
        <Modal show={showConversationModal} onHide={() => setShowConversationModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Comments</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedQuery?.conversations?.length ? (
              <ul className="space-y-4">
                {selectedQuery.conversations.map((message, index) => (
                  <li key={index}>
                    <strong>
                      {message?.sender?.name} ({message?.sender?.type}):
                    </strong>{' '}
                    {message?.text}
                  </li>
                ))}
              </ul>
            ) : (
              <p>No conversations available.</p>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowConversationModal(false)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {showEditModal && (
        <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Edit Query</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form>
              <div className="mb-3">
                <label>Status</label>
                <select className="form-control" onChange={(e) => setStatus(e.target.value)} defaultValue={status}>
                  <option value="Open">Open</option>
                  <option value="In Progress">In Progress</option>
                  <option value="Resolved">Resolved</option>
                </select>
              </div>
              <div className="mb-3">
                <label>Priority</label>
                <select className="form-control" onChange={(e) => setPriority(e.target.value)} defaultValue={priority}>
                  <option value="Low">Low</option>
                  <option value="Medium">Medium</option>
                  <option value="High">High</option>
                  <option value="Critical">Critical</option>
                </select>
              </div>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={() => handleUpdate(selectedQuery)}>
              Save Changes
            </Button>
            <Button variant="secondary" onClick={() => setShowEditModal(false)}>
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {showAddMessageModal && (
        <Modal show={showAddMessageModal} onHide={() => setShowAddMessageModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Add Message</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form>
              <div className="mb-3">
                <label>Message</label>
                <textarea
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                  className="form-control"
                  rows="3"
                ></textarea>
              </div>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowAddMessageModal(false)}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleSendMessage}>
              Send
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {selectedQuery && (
        <Modal show={showModal} onHide={() => setShowModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Edit Query</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group>
                <Form.Label>Customer Name</Form.Label>
                <Form.Control
                  type="text"
                  value={selectedQuery.customerName}
                  onChange={(e) =>
                    setSelectedQuery({
                      ...selectedQuery,
                      customerName: e.target.value,
                    })
                  }
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>Subject</Form.Label>
                <Form.Control
                  type="text"
                  value={selectedQuery.subject}
                  onChange={(e) =>
                    setSelectedQuery({
                      ...selectedQuery,
                      subject: e.target.value,
                    })
                  }
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>Status</Form.Label>
                <Form.Select
                  value={selectedQuery.status}
                  onChange={(e) =>
                    setSelectedQuery({
                      ...selectedQuery,
                      status: e.target.value,
                    })
                  }
                >
                  <option value="Open">Open</option>
                  <option value="In Progress">In Progress</option>
                  <option value="Closed">Closed</option>
                </Form.Select>
              </Form.Group>
              <Form.Group>
                <Form.Label>Priority</Form.Label>
                <Form.Select
                  value={selectedQuery.priority}
                  onChange={(e) =>
                    setSelectedQuery({
                      ...selectedQuery,
                      priority: e.target.value,
                    })
                  }
                >
                  <option value="Low">Low</option>
                  <option value="Medium">Medium</option>
                  <option value="High">High</option>
                  <option value="Critical">Critical</option>
                </Form.Select>
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModal(false)}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleSave}>
              Save Changes
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {showConfirmation && (
        <ConfirmationModal
          showModal={showConfirmation}
          title="Query will be deleted."
          closeModal={() => {
            setSelectedQuery(null);
            setConfirmation(false);
          }}
          onConfirm={() => deleteQuery()}
        />
      )}
    </div>
  );
};

const queriesList = [
  {
    id: 'LAJS23999',
    customerName: 'John',
    customerContact: { email: 'john@email.com', mobileNo: '+31 012 345 6789' },
    subject: 'Payment Issue',
    description: 'Amount deducted from my bank but payment failed on website.',
    status: 'Open',
    priority: 'High',
    raisedOn: new Date('2024, 12, 21'),
    updatedOn: null,
    assignedEmployee: { id: '923lsf', name: 'Leo' },
    assignedDate: new Date('2024, 12, 21'),
    resolution: 'Your amount will be automatically get reverted to your bank in 5-7 working days',
    followUpDate: new Date('2024, 12, 22'),
    actions: ['Issue Resolved'],
    conversations: [
      {
        sender: 'John',
        text: 'Hi, my money has been deducted but order not placed',
      },
      {
        sender: 'Employee 3',
        text: 'Sorry for the inconvenience caused to you, we have processed your refund and reflect to your bank withing 5-7 working days.',
      },
      { sender: 'John', text: 'Thanks!' },
    ],
  },
  {
    id: 'LAJS23999',
    customerName: 'John',
    customerContact: { email: 'john@email.com' },
    subject: 'Payment Issue',
    description: 'Amount deducted from my bank but payment failed on website.',
    status: 'Closed',
    priority: 'Medium',
    raisedOn: new Date('2024, 12, 21'),
    updatedOn: null,
    assignedEmployee: { id: '923lsf', name: 'Leo' },
    assignedDate: new Date('2024, 12, 21'),
    resolution: 'Your amount will be automatically get reverted to your bank in 5-7 working days',
    followUpDate: new Date('2024, 12, 22'),
    actions: ['Issue Resolved'],
  },
  {
    id: 'LAJS23999',
    customerName: 'John',
    customerContact: { email: 'john@email.com' },
    subject: 'Payment Issue',
    description: 'Amount deducted from my bank but payment failed on website.',
    status: 'Open',
    priority: 'Critical',
    raisedOn: new Date('2024, 12, 21'),
    updatedOn: null,
    assignedEmployee: { id: '923lsf', name: 'Leo' },
    assignedDate: new Date('2024, 12, 21'),
    resolution: 'Your amount will be automatically get reverted to your bank in 5-7 working days',
    followUpDate: new Date('2024, 12, 22'),
    actions: ['Issue Resolved'],
  },
  {
    id: 'LAJS23999',
    customerName: 'John',
    customerContact: { email: 'john@email.com' },
    subject: 'Payment Issue',
    description: 'Amount deducted from my bank but payment failed on website.',
    status: 'Open',
    priority: 'Low',
    raisedOn: new Date('2024, 12, 21'),
    updatedOn: null,
    assignedEmployee: { id: '923lsf', name: 'Leo' },
    assignedDate: new Date('2024, 12, 21'),
    resolution: 'Your amount will be automatically get reverted to your bank in 5-7 working days',
    followUpDate: new Date('2024, 12, 22'),
    actions: ['Issue Resolved'],
  },
];

export default Queries;
